// Styles
import './template-article.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateArticle = (context) => {
  const templateArticleSection = context.closest('.shopify-section');
}

if(document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.article__container'), (el) => {
    window.dAgency.initTemplateArticle(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.article__container'), (el) => {
      window.dAgency.initTemplateArticle(el);
    });
  });
}
